export const ELEMENT_NAMES = {
	ROOT: 'data-table',
	TABLE_ACTION_CELL: 'data-table__cell--action',
	TABLE_ACTION_CELL_CONTROL: 'data-table__cell--action__control',
	TABLE_BODY: 'data-table__table__body',
	TABLE_BODY_CELL: 'data-table__cell--body',
	TABLE_BODY_ROW: 'data-table__row--body',
	TABLE_HEAD: 'data-table__table__head',
	TABLE_HEADER_CELL: 'data-table__cell--header',
	TOOLBAR_CHIP_SET: 'data-table__tool-bar__chip-set',
	TOOLBAR_CHIP_SET_CHIP: 'data-table__tool-bar__chip-set__chip',
	TOOLBAR_TEXT_FIELD: 'data-table__tool-bar__text-field',
};

export const CSS_CLASSES = {
	DEFAULT: 'data-table--default',
	DISABLED: 'data-table--disabled',
	HIDDEN_PROGRESS_BAR: 'data-table__progress-bar--hidden',
	ICON_LEGEND: 'data-table__icon-legend',
	INTERACTIVE_TABLE_HEADER_CELL: 'data-table__cell--header--interactive',
	INVALID: 'data-table--invalid',
	ICON_LEGEND_BUTTON: 'data-table__icon-legend__button',
	LOADING_TABLE_BODY: 'data-table__body--loading',
	MULTI_TOOL_TOOLBAR: 'data-table__tool-bar--multi-tool',
	PROGRESS_BAR: 'data-table__progress-bar',
	ROOT: ELEMENT_NAMES.ROOT,
	ROOT_CONTAINER: 'data-table__container',
	SUCCEEDING_PROGRESS_BAR: 'data-table__progress-bar__container',
	SUCCEEDING_TABLE: 'data-table--succeeding',
	TABLE_ACTION_CELL: ELEMENT_NAMES.TABLE_ACTION_CELL,
	TABLE_CONTAINER: 'data-table__table__container',
	TABLE_HEADER_CELL: ELEMENT_NAMES.TABLE_HEADER_CELL,
	TABLE_ICON_CELL: 'data-table__cell--icon',
	TOOLBAR: 'data-table__tool-bar',
	TOOLBAR_CHIP_SET: ELEMENT_NAMES.TOOLBAR_CHIP_SET,
	TOOLBAR_CHIP_SET_CONTAINER: 'data-table__tool-bar__chip-set__container',
	TOOLBAR_TEXT_FIELD: 'data-table__tool-bar__text-field',
	VALID: 'data-table--valid',
	WARNING: 'data-table--warning',
	HOVER: 'data-table__row--body--hover',
};
